///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated = abcsetup.short_dated || {};
abcsetup.short_dated.responses = abcsetup.short_dated.responses || {};
abcsetup.short_dated.responses.create = abcsetup.short_dated.responses.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated.responses.create = {
    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // TODO: split aparent the common lib between opportunities + responses
        abcsetup.short_dated_opportunity.common.bindFields();
    },

    init: function () {

        $('form').on('submit', (e) => {
            abcsetup.blockUI(true);
        })

        $('.edit-item-modal-save').on('click', function(e) {
            abcsetup.blockUI();
            id = $(this).data("id")
            form = $('#edit-item-modal-' + id + ' :input').serialize();

            axios.post('/api/short_dated_item/update_item', form)
                .then((response) => {
                    if (response) {
                        abcsetup.unblockUI();
                        $('#edit-short-dated-item-modal-' + id).modal('hide');
                        location.reload();
                    }
                })
                .catch((error) => {
                    abcsetup.unblockUI();
                });
        });
    }
}
